import Agreement from './agreement';
export default Agreement;
